import Axios from "../utils/union-axios";

interface RootObject {
  stationId?: number;
  address: string;
  city: string;
  cityCode: string;
  district: string;
  districtCode: string;
  fee: number;
  floor: number;
  illustrate: string;
  latitude: string;
  location: undefined;
  longitude: string;
  parkingSpaceNo: string;
  phoneNo: string;
  pileNo: string;
  province: string;
  provinceCode: string;
  uid: string;
  userNickName: string;
  weChatNo: string;
}

/**
 * 桩主申请
 */
export function shareOpenApply(data: RootObject) {
  return Axios.post(`/web-h5/charge/private-pile/share/shareOpenApply`, data);
}

/**
 * 修改申请资料
 */
export function shareStationModifyApply(data: RootObject) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/shareStationModifyApply`,
    data
  );
}

/**
 * 获取图片ossKey
 */
export function getToken({
  businessType = "privatePileShareStationFile",
  fileName
}) {
  return Axios.post(`/web-h5/charge/oss/getToken`, { businessType, fileName });
}

/**
 * 获取图片ossKey
 */
export function getCdnAuthNUrl({
  businessType = "privatePileShareStationFile",
  fileNameList
}) {
  return Axios.post(`/web-h5/charge/oss/getCdnAuthNUrl`, {
    businessType,
    fileNameList
  });
}

/**
 * 获取桩状态信息
 */
export function pileStatus(data) {
  return Axios.post(`/web-h5/charge/private-pile/share/pileStatus`, data);
}

/**
 * 查询家充共享站点信息
 */
export function queryShareStationInfo(data) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/queryShareStationInfo`,
    data
  );
}

/**
 * 当前用户基本信息
 */
export function queryCurrentUserBasicInfo() {
  return Axios.get(`/web-h5/user/queryCurrentUserBasicInfo`);
}

/**
 * 查询家充共享申请信息
 */
export function queryShareApplyInfo(data) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/queryShareApplyInfo`,
    data
  );
}

/**
 * 查询当前用户申请使用私桩进度
 */
export function queryApplyUseProgress(data) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/queryApplyUseProgress`,
    data
  );
}

/**
 * 取消申请
 */
export function cancelApply(data) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/cancelApply`,
    data
  );
}

/**
 * 查询用户私桩共享信息
 */
export function querySharePileInfo() {
  return Axios.get(
    `/web-h5/charge/private-pile/share/querySharePileInfo`
  );
}

//获取最新安装工单信息
export function getLatestOrder({
  pileNo
}: {
  pileNo: string;
}): Promise<any> {
  return Axios.post(
    '/web-h5/charge/privatePile/homecharge/getLatestOrder',
    {
      pileNo
    }
  );
}

/**
 * 查询家充共享最新申请信息接口
 */
export function queryShareNewestApplyInfo(data) {
  return Axios.post(
    `/web-h5/charge/private-pile/share/queryShareNewestApplyInfo`,
    data
  );
}
